// extracted by mini-css-extract-plugin
module.exports = {"form":"create_form__5z8fg","inputContainerGroup":"create_inputContainerGroup__19Kgu","logoContainer":"create_logoContainer__YEFiF"};